import React, { useEffect } from "react";
import dayjs from "dayjs";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import CircularProgress from "@mui/material/CircularProgress";
import VehicleRouteCard from "../vehicleRouteCard/vehicleRouteCard";
import { useAppDispatch, useAppSelector } from "../../../framework/customStore";
import {
    setTripStartDate,
    setTripEndDate,
    fetchVehicleTripSegments,
    setSelectedRouteId,
    setHoveredRouteId,
} from "../../../store/monitorViewSlice";
import CompactDatePicker from "../../framework/compactDatePicker";
import { useTranslation } from "react-i18next";
import { handleApiError } from "../../../models/store/storeEffects";
import { tripSegmentParams } from "../monitorViewUtils";

export const MonitorViewVehicleRoutes = ({
}) => {
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const tripStartDate = useAppSelector((state) => state.monitorView.tripStartDate);
    const selectedVehicleId = useAppSelector((state) => state.monitorView.selectedVehicleId);
    const loading = useAppSelector((state) => state.monitorView.loading);

    const handleDateChange = (val: Date | null) => {
        if (val) {
            const startDate = dayjs(val).startOf("day").toDate();
            const endDate = dayjs(startDate).add(1, "day").toDate();

            dispatch(setTripStartDate(startDate));
            dispatch(setTripEndDate(endDate));

            if (selectedVehicleId) {
                try {
                    dispatch(
                        fetchVehicleTripSegments(
                            tripSegmentParams(selectedVehicleId, startDate)
                        ) as any
                    );
                } catch (e) {
                    handleApiError(
                        t("monitorView.fetchingTripsFailed", { reason: e }),
                        dispatch
                    );
                }
            }
        }
    };

    useEffect(() => {
        try {
            dispatch(
                fetchVehicleTripSegments(
                    tripSegmentParams(selectedVehicleId, tripStartDate)
                ) as any
            );
        } catch (e) {
            handleApiError(
                t("monitorView.fetchingTripsFailed", { reason: e }),
                dispatch
            );
        }

    }, []);

    return (
        <>
            <CompactDatePicker
                value={tripStartDate}
                onChange={(val) => {
                    void handleDateChange(val);
                }}
                sx={{ margin: 0.5 }}
            />
            {loading ? (
                <Box display="flex" justifyContent="center" p={2}>
                    <CircularProgress />
                </Box>
            ) : (
                <VehicleRouteList />
            )}
        </>
    );
};

const VehicleRouteList = () => {
    const dispatch = useAppDispatch();
    const selectedRouteId = useAppSelector((state) => state.monitorView.selectedRouteId);
    const selectedVehicleId = useAppSelector((state) => state.monitorView.selectedVehicleId);
    const vehicleRoute = useAppSelector((state) => state.monitorView.vehicleRoute);

    let stopIndex = 0;

    return (
        <List dense disablePadding>
            {vehicleRoute?.map((tripSegment, index) => {
                if (tripSegment.state === "Stopped") {
                    stopIndex += 1;
                }

                // Form a simpler unique ID using selectedVehicleId and index
                const uniqueId = `${selectedVehicleId}-${index}`;

                return (
                    <VehicleRouteCard
                        key={uniqueId}
                        tripSegment={tripSegment}
                        isSelected={uniqueId === selectedRouteId}
                        onClick={() => dispatch(setSelectedRouteId(uniqueId))}
                        onMouseEnter={() => dispatch(setHoveredRouteId(uniqueId))}
                        onMouseLeave={() => dispatch(setHoveredRouteId(null))}
                        stopIndex={tripSegment.state === "Stopped" ? stopIndex : undefined}
                    />
                );
            })}
        </List >
    );
};